<template>
  <require from="controls/bs-form-lookup"></require>

  <bs-form-lookup label.bind="aviationCOEGroupLabel" placeholder="Find by name, login or email" item.bind="model.aviationCOE & validate:supportValidationController" options.bind="usersLookupOptions" value-path="name" template-path="templates/user-lookup.html" stick-mode="true" tooltip="Type to search for bp employee, then pick the one from the list" maxlength="100" disabled.bind="disabled"></bs-form-lookup>
  <div class="form-group form-check">
    <input class="form-check-input ${model.isSupportedByAviationCOE ? '' : 'is-invalid'}" type="checkbox" checked.bind="model.isSupportedByAviationCOE" disabled.bind="disabled">
    <label class="form-check-label">Approved by Aviation Discipline Manager</label>
  </div>
</template>
